exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "testingua {\r\n    padding-bottom:4px;\r\n    padding-top:4px;\r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/upload-checker/upload-checker.component.css
// module id = ../../../../../src/app/upload-checker/upload-checker.component.css
// module chunks = 1